import React, { ReactElement } from 'react';
import TableRow from '../../../../components/table-row/table-row.component';
import VisibleCell from '../../../../components/visible-cell/visible-cell.component';
import DealCapitalizationRowForm from '../deal-capitalization-row-form/deal-capitalization-row-form.component';

const DealCapitalizationRow: ReactMemoComponent = React.memo((props: ReactComponentProps): ReactElement => {
  const {
    isActive,
    isSaving,
    isSaveDisabled,
    isInlineSaving,
    isNewDeal,
    isEditMode,
    isCustomizeMode,
    isSimpleView,
    dealCapitalizationGroup,
    dealCapitalizationItem,
    dealCapitalizationItemIndex,
    dealCapitalizationCategory,
    dealCapitalizationDynamicData,
    dealCapitalizationNewItems,
    dealCapitalizationItems,
    inputRefs,
    currentUser,
    deleteItemPermissions,
    tableDealCapitalizationListFields,
    dealCapitalizationTypeList,
    dealCapitalizationGroupList,
    onInlineSave,
    onInlineCancel,
    onItemChange,
    onDeleteClick,
    onOpenModal,
  } = props;

  return (
    (isEditMode || isNewDeal) ? (
      <DealCapitalizationRowForm
        isActive={isActive}
        isSaving={isSaving}
        isSaveDisabled={isSaveDisabled}
        isInlineSaving={isInlineSaving}
        isSimpleView={isSimpleView}
        currentUser={currentUser}
        inputRefs={inputRefs}
        deleteItemPermissions={deleteItemPermissions}
        dealCapitalizationItemIndex={!isSimpleView ? dealCapitalizationItemIndex : null}
        dealCapitalizationItemData={dealCapitalizationItem}
        dealCapitalizationGroupData={dealCapitalizationGroup}
        dealCapitalizationCategory={dealCapitalizationCategory}
        dealCapitalizationItemDynamicData={dealCapitalizationDynamicData}
        dealCapitalizationNewItems={dealCapitalizationNewItems}
        dealCapitalizationItems={dealCapitalizationItems}
        dealCapitalizationTypeList={dealCapitalizationTypeList}
        dealCapitalizationGroupList={dealCapitalizationGroupList}
        onInlineSave={onInlineSave}
        onInlineCancel={onInlineCancel}
        onItemChange={onItemChange}
        onOpenModal={(): void => {
          onOpenModal(dealCapitalizationItem, dealCapitalizationGroup);
        }}
        onDeleteClick={(event: React.MouseEvent<Element, MouseEvent>): void => {
          onDeleteClick(event, dealCapitalizationItem.id, dealCapitalizationGroup.id);
        }}
      />
    ) : (
      <TableRow isButton={!isCustomizeMode}>
        {
          tableDealCapitalizationListFields && !!tableDealCapitalizationListFields.length
          && tableDealCapitalizationListFields.map((tableField: TableField): ReactElement => (
            <VisibleCell
              isFullTable={!isSimpleView}
              isEditMode={isEditMode || isNewDeal}
              key={tableField.id}
              tableField={tableField}
            >
              {!!tableField.component && tableField.component(dealCapitalizationItem)}
            </VisibleCell>
          ))
        }
      </TableRow>
    )
  );
});

export default DealCapitalizationRow;
